import { render, staticRenderFns } from "./CandidateNoteInput.html?vue&type=template&id=fb24013c&scoped=true&external"
import script from "./CandidateNoteInput.js?vue&type=script&lang=js&external"
export * from "./CandidateNoteInput.js?vue&type=script&lang=js&external"
import style0 from "./CandidateNoteInput.scss?vue&type=style&index=0&id=fb24013c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb24013c",
  null
  
)

export default component.exports